module.exports = __webpack_public_path__ + "static/media/covid-act-now-logo-url-dark.88f99a5f.png";